import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Framework from "@/pages/Framework";
import Pilot from "@/pages/Pilot";
import Partnerships from "@/pages/Partnerships";
import Research from "@/pages/Research";
import Governance from "@/pages/Governance";
import Architect from "@/pages/Architect";
import Resources from "@/pages/Resources";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain bg-ink text-slate-100 min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/framework" element={<Framework />} />
          <Route path="/pilot" element={<Pilot />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/research" element={<Research />} />
          <Route path="/governance" element={<Governance />} />
          <Route path="/architect" element={<Architect />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/accessibility" element={<Legal page="accessibility" />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
